import FadeIn from "./FadeIn";
import { useLang } from "../../contexts/LanguageContext";
import { imageUrl } from "../../lib/api";

export default function WhoWeAre({ content }) {
  const { t } = useLang();
  const stats = content?.who_we_are?.stats || [];
  const expertise = content?.expertise?.items || [];
  const whoImg = content?.who_we_are?.image ? imageUrl(content.who_we_are.image) : null;

  return (
    <section
      id="about"
      className="container-x py-24 md:py-32 hairline-t"
      data-testid="who-we-are-section"
    >
      <FadeIn>
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12 items-start">
          <div className="md:col-span-7">
            <div className="eyebrow mb-8">{t(content?.who_we_are?.eyebrow)}</div>
            <h2
              className="font-display font-semibold text-[#16181c] text-3xl sm:text-4xl md:text-5xl leading-[1.1] tracking-[-0.02em]"
              data-testid="who-we-are-statement"
            >
              {t(content?.who_we_are?.statement)}
            </h2>
            <p className="mt-6 text-[#5d5f64] text-base md:text-[17px] leading-relaxed max-w-[60ch]">
              {t(content?.who_we_are?.paragraph)}
            </p>

            <div className="mt-12 grid grid-cols-3 gap-4 md:gap-8" data-testid="who-we-are-stats">
              {stats.map((s, i) => (
                <div key={i} className="border-t border-[#e3e3e1] pt-4">
                  <div className="font-display font-bold text-[#16181c] text-3xl md:text-4xl tracking-[-0.02em]">
                    {s.value}
                  </div>
                  <div className="mt-2 text-[13px] text-[#5d5f64] leading-snug">{t(s.label)}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="md:col-span-5">
            <div className="relative aspect-[4/5] bg-[#1b1c1e] overflow-hidden">
              {whoImg ? (
                <img
                  src={whoImg}
                  alt=""
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="absolute inset-0 bg-gradient-to-br from-[#1b1c1e] to-[#2a2c30]" />
              )}
            </div>
          </div>
        </div>
      </FadeIn>

      <FadeIn>
        <div className="mt-24 md:mt-32">
          <div className="flex items-end justify-between flex-wrap gap-6 mb-12">
            <div>
              <div className="eyebrow mb-6">{t(content?.expertise?.eyebrow)}</div>
              <h3 className="font-display font-bold text-[#16181c] text-3xl sm:text-4xl md:text-5xl leading-[1.05] tracking-[-0.02em]">
                {t(content?.expertise?.heading)}
              </h3>
            </div>
          </div>

          <div
            className="grid grid-cols-1 md:grid-cols-3 border-l border-t border-[#e3e3e1]"
            data-testid="expertise-grid"
          >
            {expertise.map((e, i) => (
              <div
                key={i}
                className="border-r border-b border-[#e3e3e1] p-8 md:p-10 min-h-[200px] flex flex-col"
                data-testid={`expertise-item-${i}`}
              >
                <h4 className="font-display font-semibold text-[#16181c] text-xl md:text-2xl tracking-[-0.01em]">
                  {t(e.title)}
                </h4>
                <p className="mt-3 text-[#5d5f64] text-[15px] leading-relaxed flex-1">
                  {t(e.description)}
                </p>
                {e.sbu && <div className="eyebrow mt-6">SBU · {e.sbu}</div>}
              </div>
            ))}
          </div>
        </div>
      </FadeIn>
    </section>
  );
}
